module.exports = __webpack_public_path__ + "img/9788954429894.779866d2.jpg";